import { get, post } from '../utils/fetch';

// Server Side Include
export const SsiApi = {
  getStaticHtml: async (
    serviceId: number,
    serviceAttribute: number,
  ): Promise<string> => {
    const url = `/api/ssi/static/${serviceId}/${serviceAttribute}`;

    return await get(url, 'getStaticHtml');
  },

  getHtmlFromSsiUrl: async (
    serviceId: number,
    serviceAttribute: number,
    ssiUrl: string,
  ): Promise<string> => {
    const url = `/api/ssi/${serviceId}/${serviceAttribute}`;

    return await post(url, { ssiUrl }, 'getHtmlFromSsiUrl');
  },
};
